<template>
  <div style="padding:20px;">
    <el-row :gutter="20">
      <el-row style="margin-bottom: 10px;">
        <el-input class="search-el" size="small" v-model="query.word" placeholder="请输入关键词"></el-input>
        <el-select v-model="query.scope" placeholder="请选择" size="small">
          <el-option label="全部" :value="0">全部</el-option>
          <el-option label="通用" :value="1">通用</el-option>
          <el-option label="心理咨询" :value="3">心理咨询</el-option>
          <el-option label="课程" :value="2">课程</el-option>
        </el-select>
        <el-button type="primary" size="small" @click="getListQuery()" :loading="listLoading">
          查询
        </el-button>
        <el-button type="primary" size="small" @click="createInfo()">增加关键词</el-button>
        <el-button type="primary" size="small" @click="batchCreateInfo()">批量增加关键词</el-button>
      </el-row>
      <el-table size="small" :data="listData" style="width: 100%" border >
        <el-table-column prop="id" label="ID" width="90"></el-table-column>
        <el-table-column prop="scope" label="类型" width="90">
          <template slot-scope="{row}">
            <div>{{ row.scope==1?'通用':row.scope==2?'课程':'心理咨询' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="word" label="关键词" width="400"></el-table-column>
        <el-table-column prop="created_at" label="创建时间"></el-table-column>
        <el-table-column prop="updated_at" label="修改时间"></el-table-column>

        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button type="primary" size="small" @click="updateInfo(row.id)">修改</el-button>
            <el-button type="danger" size="small" @click="deleteInfo(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top:10px">
        <el-pagination background @current-change="getList" :current-page.sync="query.page"
                       :page-size="query.limit"
                       layout="total, prev, pager, next, jumper" :total="listTotal">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getList, deleteWord
} from "@/api/sensitive";

export default {
  data:function () {
    return {
      listData:[],
      listLoading:false,
      listTotal:0,
      query:{
        limit:20,
        word:'',
        page:1,
        scope:0
      }
    }
  },
  created: function() {
    this.getList();
  },
  methods: {
    getListQuery(){
      this.query.page = 1
      this.getList()
    },
    getList(){
      this.listLoading = true;
      getList(this.query).then(response => {
        this.listData = response.data.list
        this.listTotal = response.data.total
        this.listLoading = false;
      });
    },
    updateInfo(id){
      this.$router.push({
        path: "/sensitive/info",
        query: {type:'update', id:id}
      });
    },
    createInfo(){
      this.$router.push({
        path: "/sensitive/info",
        query: {type:'create'}
      });
    },
    batchCreateInfo(){
      this.$router.push({
        path: "/sensitive/batchCreate",
      });
    },
    deleteInfo(id){
      this.$confirm('此操作将删除信息，是否确认操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        deleteWord({id}).then(response => {
          this.listLoading = false;
          if(response.code == 1){
            this.getList();
            this.$message({
              showClose: true,
              duration: 6000,
              message: '删除成功',
              type: 'success'
            });
          }
        });
      }).catch(() => {

      });
    }
  },
}
</script>